import React, { Suspense, useState, useEffect } from "react";

const GoogleMapComponent = React.lazy(() =>
  import('@react-google-maps/api').then((module) => ({
    default: module.GoogleMap,
  }))
);

const MarkerComponent = React.lazy(() =>
  import('@react-google-maps/api').then((module) => ({
    default: module.Marker,
  }))
);

const mapContainerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "12px",
};

const defaultCenter = {
  lat: 37.7749, 
  lng: -122.4194,
};

const loadGoogleMapsScript = (googleMapsApiKey) => {
  return new Promise((resolve, reject) => {
    if (window.google) {
      resolve(window.google);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places&async=true&defer=true`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve(window.google);
    script.onerror = (error) => {
      console.error('Google Maps API failed to load', error);
      reject(error);
    };

    document.head.appendChild(script);
  });
};

const MapChart = ({ selectedLocation }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [position, setPosition] = useState(defaultCenter);

  useEffect(() => {
    loadGoogleMapsScript('AIzaSyDiCHuJKYUQoHDkOO8wOKM8-XoX0jTxtSo')
      .then(() => setIsLoaded(true))
      .catch((error) => {
        console.error('Google Maps API failed to load', error);
        setIsLoaded(false);
      });
  }, []);

  useEffect(() => {
    if (selectedLocation && selectedLocation.latitude && selectedLocation.longitude) {
      setPosition({
        lat: selectedLocation.latitude,
        lng: selectedLocation.longitude,
      });
    }
  }, [selectedLocation]);

  if (!isLoaded) {
    return <p></p>;
  }

  const handleMarkerDragEnd = (event) => {
    const newPosition = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };
    setPosition(newPosition);
  };

  return (
    <Suspense fallback={<div></div>}>
      <GoogleMapComponent
        mapContainerStyle={mapContainerStyle}
        center={position}
        zoom={6}
      >
        <MarkerComponent
          position={position}
          draggable={true}
          onDragEnd={handleMarkerDragEnd}
        />
      </GoogleMapComponent>
    </Suspense>
  );
};

export default MapChart;
